var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['icon-button', _vm.sizeClass],style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }